import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useOccConfig } from '../../../context/occ/hooks/use-occ-config';
const b = bemClassBuilder('v-captcha');
export const CaptchaSkeleton = observer(() => {
    const { captcha: captchaConfig } = useOccConfig().security;
    if (!captchaConfig) {
        return null;
    }
    return _jsx("div", { className: b.block({ skeleton: true, type: captchaConfig.type, size: captchaConfig.size }) });
});
CaptchaSkeleton.displayName = 'CaptchaSkeleton';
//# sourceMappingURL=skeleton.js.map